import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useMapLayerAttributionsStyles = makeStyles(({ spacing }) => {
  return createStyles({
    attribution: {
      position: 'absolute',
      bottom: spacing(2.5),
      right: spacing(2.5),
    },
  });
});

export default useMapLayerAttributionsStyles;
